export default "__VITE_ASSET__D_K8lKOK__"